/**
 * Weekly recurrence configuration component with day selector
 */
export function WeeklyRecurrenceConfig({ recurrence, onChange }) {
  const daysOfWeek = [
    { id: 1, label: 'M', name: 'Montag' },
    { id: 2, label: 'D', name: 'Dienstag' },
    { id: 3, label: 'M', name: 'Mittwoch' },
    { id: 4, label: 'D', name: 'Donnerstag' },
    { id: 5, label: 'F', name: 'Freitag' },
    { id: 6, label: 'S', name: 'Samstag' },
    { id: 0, label: 'S', name: 'Sonntag' }
  ];

  const toggleDay = (dayId) => {
    const currentDays = recurrence.daysOfWeek || [];
    const newDays = currentDays.includes(dayId)
      ? currentDays.filter(d => d !== dayId)
      : [...currentDays, dayId].sort();

    onChange({ ...recurrence, daysOfWeek: newDays });
  };

  return (
    <div className="recurrence-config">
      <div className="form-group">
        <label>Alle wie viele Wochen?</label>
        <input
          type="number"
          min="1"
          max="99"
          value={recurrence.interval || 1}
          onChange={(e) => onChange({ ...recurrence, interval: parseInt(e.target.value) })}
          style={{ width: '100px' }}
        />
        <span className="input-suffix">Woche(n)</span>
      </div>

      <div className="form-group">
        <label>Wochentage auswählen *</label>
        <div className="weekday-selector">
          {daysOfWeek.map(day => (
            <button
              key={day.id}
              type="button"
              className={`weekday-btn ${(recurrence.daysOfWeek || []).includes(day.id) ? 'selected' : ''}`}
              onClick={() => toggleDay(day.id)}
              title={day.name}
            >
              {day.label}
            </button>
          ))}
        </div>
      </div>

      <div className="form-row form-row-2">
        <div className="form-group">
          <label>Startdatum *</label>
          <input
            type="date"
            value={recurrence.startDate}
            onChange={(e) => onChange({ ...recurrence, startDate: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <label>Enddatum (optional)</label>
          <input
            type="date"
            value={recurrence.endDate || ''}
            onChange={(e) => onChange({ ...recurrence, endDate: e.target.value || null })}
            min={recurrence.startDate}
          />
        </div>
      </div>
    </div>
  );
}
